import InputUpload from './components/Upload/Upload';

export default InputUpload;
